<template>
  <div>
    <!-- session -->
    <div
      class="flex flex-row p-4 mb-2 border border-solid rounded items-center"
      v-if="integration.isActive"
    >
      <!-- user name -->
      <div
        class="w-1/2 h-full flex md:flex-row flex-col mr-20 md:mr-0 items-center md:items-end"
      >
        <div class="flex md:justify-center">
          <img :src="imageUrl" class="h-10 w-10" />
        </div>
        <div
          class="relative flex flex-row flex-start capitalize font-bold"
          style="flex: 1 1 50%"
        >
          <div
            class="flex justify-start md:absolute md:bottom-0 md:mb-2 mt-2 md:mt-0 md:ml-5 w-full"
          >
            {{ integration.name }}
          </div>
        </div>
      </div>

      <!-- delete -->
      <div class="flex justify-end w-1/2">
        <div class="md:table-cell flex md:flex-row flex-col leading-none">
          <!-- edit employee -->
          <r-button
            id="edit-integration"
            class="md:mr-4"
            :style="integration.name === 'zapier' ? 'visibility: hidden;' : ''"
            @click="onEditIntegration"
          >
            {{ $t("buttons.edit") }}
          </r-button>

          <!-- remove employee -->
          <r-button
            id="delete-integration"
            class="flex-1"
            :style="integration.name === 'zapier' ? 'visibility: hidden;' : ''"
            color="error"
            @click="onDeleteIntegration"
          >
            {{ $t("buttons.delete") }}
          </r-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // props
  props: {
    integration: {
      type: Object,
      default: () => ({})
    }
  },

  // computed properties
  computed: {
    /**
     * Get image url by integration name
     */
    imageUrl() {
      return require(`@/assets/icons/${this.integration.name}-mini.png`)
    }
  },

  // methods
  methods: {
    /**
     * On edit integration
     */
    onEditIntegration() {
      this.$emit("on-edit", this.integration.name)
    },

    /**
     * On Delete integration
     */
    onDeleteIntegration() {
      this.$emit("on-delete", this.integration.name)
    }
  }
}
</script>
